import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "leftAlign" }
const _hoisted_2 = {
  class: "lightText",
  style: {"font-size":"12px"}
}
const _hoisted_3 = {
  key: 0,
  class: "rightAlign"
}
const _hoisted_4 = {
  key: 0,
  class: "icon_more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_PopoverMenu = _resolveComponent("PopoverMenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["info post--info post-info-container", { fromProfilePostCard: _ctx.fromProfilePostCard }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.post.type == 'text')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 0,
            path: "/create_post",
            className: "postInfo_icon",
            icon: "Create Post_Text_Three.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'analysis')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 1,
            path: "/create_post",
            className: "postInfo_icon",
            icon: "Create Post_Analysis_three.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'profile')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 2,
            path: "/create_post",
            className: "postInfo_icon",
            icon: "Create Post_Profile_Three.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'media')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 3,
            path: "/create_post",
            className: "postInfo_icon",
            icon: "Create Post_Media.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'charts')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 4,
            path: "/create_post",
            className: "postInfo_icon",
            icon: "Create Post_Charts.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'watchList')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 5,
            path: "/create_post",
            className: "postInfo_icon",
            icon: "Create Post_Watchlist.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'portfolio')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 6,
            path: "/create_post",
            className: "postInfo_icon",
            style: {"margin-top":"-5px"},
            icon: "Create Post_Trades_two.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'paper')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 7,
            path: "/create_post",
            className: "postInfo_icon",
            icon: "Create Post_Watchlist.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'repost')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 8,
            path: "/post_card",
            className: "postInfo_icon",
            icon: "icons_retweet.svg"
          }))
        : _createCommentVNode("", true),
      (_ctx.post.type == 'club')
        ? (_openBlock(), _createBlock(_component_IconComponent, {
            key: 9,
            path: "/post_card",
            className: "postInfo_icon f-s",
            icon: "icons_club.svg"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(`common.common.${_ctx.post.type.toUpperCase()}`)), 1)
    ]),
    (!_ctx.fromOutside)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.isSavedPost)
            ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
                (_ctx.isMine)
                  ? (_openBlock(), _createBlock(_component_PopoverMenu, {
                      key: 0,
                      trigger: "hover",
                      menuItems: _ctx.menuItems,
                      placement: "bottom-end"
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_IconComponent, {
                          path: "/post_card",
                          icon: "icons_more.svg",
                          class: "postInfo_icon"
                        })
                      ]),
                      _: 1
                    }, 8, ["menuItems"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}